export default __webpack_public_path__ + "static/bg-reporting-light-0aae84dcadd00b4abb6c955c5840a01c.png";